import { CSSProperties } from 'react'

import theme from '../../styles/themes/default.theme'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
    gap: theme.spacing(4),
    borderRadius: theme.shape.borderRadius,
    width: '80%',
    marginTop: theme.spacing(10),
    [theme.breakpoints.down('md')]: {
      paddingX: theme.spacing(0),
      marginTop: theme.spacing(3)
    }
  } as CSSProperties,

  iconContainer: {
    backgroundColor: theme.palette.success.main,
    borderRadius: '100%',
    padding: '1rem',
    width: '80px',
    height: '80px'
  } as CSSProperties,

  icon: {
    width: '48px',
    height: '48px',
    color: 'white'
  } as CSSProperties,

  title: {
    fontSize: theme.typography.h4.fontSize,
    fontWeight: theme.typography.h4.fontWeight,
    textAlign: 'center',
    color: theme.palette.grey[900],
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.h6.fontSize,
      marginY: theme.spacing(1)
    }
  } as CSSProperties,

  description: {
    fontSize: theme.typography.body1.fontSize,
    color: theme.palette.grey[500],
    textAlign: 'center'
  } as CSSProperties,

  orderReferenceRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  } as CSSProperties,

  orderReferenceLabel: {
    fontSize: 14,
    fontWeight: 400,
    color: theme.palette.grey[500]
  } as CSSProperties,

  orderReferenceValue: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.primary.main
  } as CSSProperties,

  labelingInstructions: {
    width: '100%',
    maxWidth: 500,
    padding: theme.spacing(3),
    backgroundColor: theme.palette.primary.light ? `${theme.palette.primary.light}15` : theme.palette.grey[50],
    borderRadius: theme.shape.borderRadius / 4,
    border: `1px dashed ${theme.palette.primary.main}`,
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  } as CSSProperties,

  labelingTitle: {
    fontSize: 16,
    fontWeight: 700,
    color: theme.palette.primary.main
  } as CSSProperties,

  labelingIntro: {
    fontSize: 13,
    color: theme.palette.grey[700]
  } as CSSProperties,

  labelingSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.75)
  } as CSSProperties,

  labelingLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.grey[700]
  } as CSSProperties,

  labelingValue: {
    fontSize: 13,
    fontWeight: 600,
    color: theme.palette.grey[900]
  } as CSSProperties,

  labelingAddressValue: {
    fontSize: 13,
    fontWeight: 600,
    color: theme.palette.grey[900],
    whiteSpace: 'pre-line'
  } as CSSProperties,

  warehouseInfo: {
    width: '100%',
    maxWidth: 500,
    padding: theme.spacing(3),
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.shape.borderRadius / 4,
    border: `1px solid ${theme.palette.grey[200]}`,
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  } as CSSProperties,

  warehouseTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: theme.palette.grey[800]
  } as CSSProperties,

  warehouseSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.75)
  } as CSSProperties,

  warehouseLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.grey[700]
  } as CSSProperties,

  warehouseText: {
    fontSize: 13,
    color: theme.palette.grey[500],
    whiteSpace: 'pre-line'
  } as CSSProperties,

  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    maxWidth: '600px',
    gap: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: theme.spacing(1.5)
    }
  } as CSSProperties,

  emptyStateContainer: {
    width: '100%'
  } as CSSProperties
}

export default styles
